import React from 'react'
import { Link } from 'react-router-dom'

export default function PaymentUnsuccessful() {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-9 col-lg-7 col-xl-6">
          <div className="bcs-account-page p-4 p-sm-5 shadow-sm">
            <div className="text-center mb-4">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{ width: 64, height: 64, background: 'rgba(239, 68, 68, 0.12)' }}
              >
                <span style={{ fontSize: 28 }}>!</span>
              </div>

              <div className="brand-dark-purple h4 mb-2">Payment unsuccessful</div>
              <div className="bcs-subtitle mb-0">
                Your subscription did not go through, so your profile is not live yet.
              </div>
            </div>

            <div className="bcs-account-card bg-white p-3 p-sm-4 mb-4">
              <div className="brand-dark-purple mb-2">Try this</div>

              <div className="small" style={{ color: 'rgba(44, 27, 69, 0.75)' }}>
                <div className="mb-2">
                  <span className="me-2">•</span>
                  Check your card details and billing address
                </div>
                <div className="mb-2">
                  <span className="me-2">•</span>
                  Try a different payment method
                </div>
                <div className="mb-0">
                  <span className="me-2">•</span>
                  If your bank blocked it, approve the payment and try again
                </div>
              </div>

              <div className="mt-3">
                <span className="badge rounded-pill db-av-row-static-off px-3 py-2">
                  Not live
                </span>
              </div>
            </div>

    

            <div className="bcs-divider my-4" />

            <div className="text-center">
              <Link to="/" className="bcs-link text-decoration-none">
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}